import React from 'react'

const CopyRight = () => {
  return (
    <>
      <div className="copyright text-center">
        <p>© 2025 Neuroscience Advisors, LLC</p>
      </div>
    </>
  )
}

export default CopyRight